import { render } from "./OrdersAnalytics.vue?vue&type=template&id=10b06719&scoped=true"
import script from "./OrdersAnalytics.vue?vue&type=script&lang=js"
export * from "./OrdersAnalytics.vue?vue&type=script&lang=js"

import "./OrdersAnalytics.vue?vue&type=style&index=0&id=10b06719&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b06719"]])

export default __exports__